document.querySelectorAll('img[data-credits], img[data-description]').forEach(img => {
  const description = img.getAttribute('data-description');
  const credits = img.getAttribute('data-credits');

  const figure = document.createElement('figure');
  img.parentNode.insertBefore(figure, img);
  figure.appendChild(img);

  if (description || credits) {
    const figcaption = document.createElement('figcaption');

    if (description) {
      figcaption.innerHTML = description;
    }

    if (credits) {
      const creditsText = description ? ` (<strong>${credits}</strong>)` : `<strong>${credits}</strong>`;
      figcaption.innerHTML += creditsText;
    }
    
    figure.appendChild(figcaption);
  }
});
